import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Style from "../Style/Courses.module.scss";
import AOS from "aos";
import "aos/dist/aos.css";

const baseURL = process.env.REACT_APP_BASE_URL;

const getImageUrl = (imgPath) => {
  if (!imgPath) return "https://via.placeholder.com/300x200?text=No+Image";
  if (imgPath.startsWith("http")) return imgPath;
  return `${baseURL.replace(/\/$/, "")}/uploads/${imgPath}`;
};

const Courses = ({ darkMode }) => {
  const [courseData, setCourseData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/get/skills`);
      const coursesArray = Array.isArray(res.data) ? res.data : [];

      const fixedCourses = coursesArray.map((course) => ({
        ...course,
        image_url: getImageUrl(course.image_url),
        title: course.title || "",
        short_description: course.short_description || "",
      }));

      setCourseData(fixedCourses);

      if (fixedCourses.length === 0) setError("No courses available.");
    } catch (err) {
      console.error("Failed to fetch courses:", err);
      setError("Failed to load courses.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true });
  }, []);

  return (
    <div className={`${Style.Courses} ${darkMode ? Style.dark : ""}`}>
      <div className={Style.wrapper}>
        <div className={Style.CoursesDisk} data-aos="fade-up">
          <h4>Our Courses</h4>
          <h1>Featured Courses</h1>
        </div>

        {loading ? (
          <p style={{ textAlign: "center", width: "100%" }}>Loading...</p>
        ) : error ? (
          <p style={{ textAlign: "center", width: "100%" }}>{error}</p>
        ) : (
          <div className={Style.CoursesFlex}>
            {courseData.map((course, index) => (
              <div
                className={Style.CoursesFlexWrap}
                key={course.id}
                data-aos="zoom-in"
                data-aos-delay={`${index * 100}`}
              >
                <Link
                  to={`/${course.title.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <img
                    src={course.image_url}
                    alt={course.title}
                    loading="lazy"
                  />
                  <div className={Style.content}>
                    <h3>{course.title}</h3>
                    <p>{course.short_description}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Courses;
